const rooms = {
  0.5: "form_input_rooms_studio",
  0: "form_input_rooms_studio",
  1: "form_input_rooms_onebedroom",
  1.5: "form_input_rooms_onehalfbedroom",
  2: "form_input_rooms_twobedroom",
  2.5: "form_input_rooms_twohalfbedroom",
  3: "form_input_rooms_threebedroom",
  3.5: "form_input_rooms_threehalfbedroom",
  4: "form_input_rooms_fourbedroom",
  4.5: "form_input_rooms_fourhalfbedroom",
  5: "form_input_rooms_fivebedroom",
  5.5: "form_input_rooms_fivehalfbedroom",
  6: "form_input_rooms_sixbedroom",
  6.5: "form_input_rooms_sixhalfbedroom",
  7: "form_input_rooms_sevenbedroom",
  7.5: "form_input_rooms_sevenhalfbedroom",
  8: "form_input_rooms_eightbedroom",
  8.5: "form_input_rooms_eighthalfbedroom",
  9: "form_input_rooms_ninebedroom",
};

const floors = {
  "-1": "top_search_cat_menu_basement",
  0.5: "top_search_cat_menu_high_rise_floor",
  0: "form_input_property_ground_floor",
};

export const getRoomTypeFromTranslation = (roomNumber) => {
  return rooms[roomNumber];
};

export const getFloorTypeFromTranslation = (floor) => {
  if (floors[floor]) {
    return floors[floor];
  } else {
    return `form_input_property_${floor}_floor`;
  }
};

export const getTranslationValueByKey = (key, floor) => {
  if (floor) {
    return getFloorTypeFromTranslation(floor);
  }
  switch (key) {
    case "room":
    case "rooms":
      return "form_input_room_num";
    case "type":
      return "top_search_property_type";
    case "put":
      return "form_input_property_road";
    case "kanalizacija":
      return "form_input_property_sewage";
    case "propertyId":
      return "property_code";
    case "area":
      return "form_input_city_area";
    case "state":
      return "form_input_property_condition";
    case "propertySize":
      return "form_input_square_size";
    case "onFloor":
      return "form_input_property_floor";
    case "assist":
      return "form_input_property_assist";
    case "price":
      return "form_input_price";
    case "city":
      return "top_search_city_title";
    case "propertyValue":
      return "form_input_property_condition";
    case "standardna":
      return "form_input_property_status_standard";
    case "novogradnja":
      return "form_input_property_status_new_buildings";
    case "starogradnja":
      return "form_input_property_status_old_buildings";
    case "u izgradnji":
      return "form_input_property_status_construction_building";
    case "gradjevinsko_zemljiste":
      return "offer_property_form_building_land";
    case "poljoprivredno_zemljiste":
      return "offer_property_form_agricultural_land";
    case "vrsta":
      return "property_estate_species";
    case "tip":
      return "property_estate_type";
    case "vikendica":
      return "top_search_cat_menu_cottage";
    case "duplex_kuca":
      return "top_search_cat_menu_duplex_house";
    case "dvojna_kuca":
      return "top_search_cat_menu_double_house";
    case "spratna":
      return "top_search_cat_menu_floor_house";
    case "prizemna":
      return "offer_property_form_ground_floor";
    case "dupleks":
      return "top_search_cat_menu_duplexes";
    case "penthouse":
      return "top_search_cat_menu_penthouse";
    case "potkrovlje":
      return "top_search_cat_menu_attic";
    case "nadogradnja":
      return "top_search_cat_menu_upgrade";
    case "salonac":
      return "top_search_cat_menu_salon";
    case "dvorišni_stan":
      return "top_search_cat_menu_courtyard";
    case "prizemlje":
      return "top_search_cat_menu_ground_floor";
    case "visoko_prizemlje":
      return "top_search_cat_menu_high_rise_floor";
    case "stan_u_kuci":
      return "top_search_cat_menu_house_apartment";
    case "suteren":
      return "top_search_cat_menu_basement";
    case "garaža":
      return "form_input_garages";
    case "garaza":
      return "form_input_garages";
    case "skladista-ostave":
      return "top_search_cat_menu_warehouses_holds";
    case "kuca":
      return "menu_houses";
    case "lokal":
      return "menu_office";
    case "kancelarija":
      return "top_search_cat_menu_office";
    case "ordinacija":
      return "top_search_cat_menu_consulting_room";
    case "poslovna_zgrada":
      return "top_search_cat_menu_business_building";
    case "poslovni_prostor":
      return "offer_property_form_business_office";
    case "lokali":
      return "top_search_cat_menu_shop";
    case "magacin":
      return "top_search_cat_menu_warehouse";
    case "kiosk":
      return "top_search_cat_menu_kiosk";
    case "prodajna_hala":
      return "top_search_cat_menu_sales_hall";
    case "restoran":
      return "top_search_cat_menu_restaurant";
    case "hotel":
      return "top_search_cat_menu_hotel";
    case "kafic":
      return "top_search_cat_menu_cafe";
    case "motel":
      return "top_search_cat_menu_motel";
    case "proizvodne_hale":
      return "top_search_cat_menu_production_halls";
    case "fabrike":
      return "top_search_cat_menu_factories";
    case "radionice":
      return "top_search_cat_menu_workshops";
    case "poljoprivredni_objekti":
      return "top_search_cat_menu_agricultural_objects";
    case "teretana":
      return "top_search_cat_menu_gym";
    case "solarijum":
      return "top_search_cat_menu_solarium";
    case "sportski_tereni":
      return "top_search_cat_menu_sports_fields";
    case "wellness_centri":
      return "top_search_cat_menu_wellness_centers";
    case "plac":
      return "form_input_lot";
    case "suma":
      return "top_search_cat_menu_forest";
    case "vocnjak":
      return "top_search_cat_menu_orchard";
    case "obradiva_zemlja":
      return "top_search_cat_menu_arable_land";
    case "livade-pasnjaci":
      return "top_search_cat_menu_meadow_pastures";
    case "individualna_gradnja":
      return "top_search_cat_menu_individual_construction";
    case "industrijska_namena":
      return "top_search_cat_menu_individual_purpose";
    case "poslovna_namena":
      return "top_search_cat_menu_business_purpose";
    case "terasa":
      return "form_input_property_terrace";
    case "bašta":
      return "form_input_property_garden";
    case "basta":
      return "form_input_property_garden";
    case "parking":
      return "form_input_property_parking";
    case "balkon":
      return "form_input_property_balcony";
    case "loda":
      return "form_input_property_loggia";
    case "francuski balkon":
      return "form_input_property_french_balcony";
    case "ostava":
      return "form_input_property_storage_room";
    case "bazen":
      return "form_input_property_pool";
    case "podrum":
      return "form_input_property_basement";
    case "interfon":
      return "form_input_property_intercom";
    case "telefon":
      return "form_input_property_phone";
    case "kablovska":
      return "form_input_property_cable";
    case "internet":
      return "form_input_property_internet";
    case "klima":
      return "form_input_property_ac";
    case "video nadzor":
      return "form_input_property_video_surveillance";
    case "vodovod":
      return "form_input_property_water";
    case "pictures":
      return "form_input_property_picture";
    case "cheap":
      return "form_input_cheap_apartments";
    case "top":
      return "form_input_top_studio";
    case "priceTax":
      return "form_input_price_vat";
    case "propertyOfferLegal":
      return "form_input_property_registered";
    case "property_info":
      return "offer_property_form_information_title";
    case "property_details":
      return "property_details";
    case "builtYear":
      return "form_input_property_construction_year";
    case "daljinsko":
      return "form_input_property_remote";
    case "centralno":
      return "form_input_property_central";
    case "etažno grejanje/grejno telo":
      return "form_input_property_floor_heating_heating_body";
    case "heating":
      return "form_input_property_heating_mode";
    case "lož ulje":
      return "form_input_property_heating_mode";
    case "gas":
      return "form_input_property_gas";
    case "čvrsta goriva":
      return "form_input_property_solid_fuel";
    case "rampa za invalidska kolica":
      return "form_input_property_wheelchair_ramp";
    case "struja":
      return "form_input_property_electricity";
    case "form_input_lot":
      return "plac";
    case "menu_houses":
      return "kuca";
    case "menu_office":
      return "lokal";
    case "top_search_cat_menu_apartments":
      return "stan";
    case "stan":
      return "top_search_cat_menu_apartments";
    case "stambeni":
      return "form_input_residential_building";
    case "lift":
      return "form_input_property_elevator";
    case "rampa":
      return "form_input_property_wheelchair_ramp";
    case "15":
      return "form_input_property_15_floor";
    default:
      return null;
  }
};

export const translate = (translations, lang, key) => {
  const entry = translations?.[key];
  if (!entry || typeof entry !== "object") return "";
  return entry[lang] ?? entry.sr ?? "";
};

export const mapCategoriesToOptions = (categories, translations, lang) => {
  return categories
    .map((item) => {
      const entry = translations?.[item.type_key];
      if (!entry) return null;
      return {
        id: item.type_key,
        value: entry?.[lang] ?? entry?.sr ?? item.type_name,
      };
    })
    .filter(Boolean);
};

export const mapPictures = (pictures) => {
  if (!pictures || !Array.isArray(pictures)) return [];
  return pictures.map((pic, index) => ({
    id: pic.id,
    path: pic.url || pic.path,
    orderNum: index + 1,
    title: pic.name || "",
    date: pic.created_at,
    approved: pic.approved ?? true,
    url: pic.url,
    name: pic.name,
    size: pic.size,
  }));
};

export const mapPropertyResponse = (property) => {
  if (!property) return property;
  return {
    ...property,
    pictures: mapPictures(property.pictures),
  };
};
